import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { PdfPreviewComponent } from '@core/components/pdf-preview/pdf-preview.component';
import { pdfPreviewResolver } from '@core/resolvers';

const routes: Routes = [
  {
    path: '',
    component: PdfPreviewComponent,
    resolve: {
      resolveData: pdfPreviewResolver
    },
    runGuardsAndResolvers: 'always',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PdfPreviewRoutingModule {}
